<ngx-loading
  [show]="loading"
  [config]="{ 
    animationType: 'chasingDots',
    backdropBorderRadius: '3px',
    primaryColour: '#630f12', 
    secondaryColour: '#630f12', 
    tertiaryColour: '#ffcb05',
    backdropBackgroundColour: 'rgba(0, 0, 0, 0.5)',
    fullScreenBackdrop: true
  }"
>
  <div *ngIf="loading" style="color: white; font-size: 16px; margin-top: 20px; text-align: center;">
    Loading...
  </div>
</ngx-loading>
<div>
  <div class="login-page">
    <div>
      <mat-card class="login-card ml-auto mr-auto">
        <mat-card-header>
          <mat-card-title>
            <h2>Admin Login</h2>
          </mat-card-title>
          <mat-card-subtitle>
            <h6>Welcome to AUCDT Online Admissions Admin Portal. Enter your Login credentials.</h6>
          </mat-card-subtitle>
        </mat-card-header>
        <div class="login-form">
          <mat-card-content>
            <form>
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Email</mat-label>
                <input matInput type='email' [(ngModel)]="usermail" placeholder="Eg. bright.agbosu@gmail.com"
                  name="usermail" required>
              </mat-form-field>
              <br>
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Password</mat-label>
                <input [(ngModel)]="password" type="password" matInput name="password" required>
              </mat-form-field>
            </form>
          </mat-card-content>
          <button mat-raised-button class="btn-block" (click)="captureCredential()">
            <a mat-button routerLinkActive="active">LOGIN</a>
          </button>
        </div>

      </mat-card>
    </div>
  </div>
</div>